import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { Card, Form, Label } from "reactstrap";
import {
  addLMSPreviousYearQuestionAPI,
  getClassDD,
  getSessionDD,
  getStreamByClassDD,
  getSubjectByClassLMSDD,
  listLMSPreviousYearQuestionAPI,
  updateLMSPreviousYearQuestionAPI,
} from "../../../api/LMS/master";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
} from "../../../components/Component";
import useLogout from "../../../hooks/useLogout";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import Required from "../../../myComponents/validate/Required";
import { toast } from "react-toastify";
import PdfUpload from "../../../myComponents/form/PdfUpload";
import { ValidatePdf } from "../../../utils/Utils";
import MyButton from "../../../myComponents/form/MyButton";
import MyDataTable from "../../../myComponents/DataTable/MyDataTable";
import { FaFilePdf, FaYoutube } from "react-icons/fa";
import { hasPermission } from "../../../utils/myFunctions";
import { decrypt } from "../../../utils/Encrypt";
import { BASE_URL_IMG_LMS } from "../../../assets/constants/constants";
import ViewImgAndPdf from "../../../myComponents/modals/ViewImgAndPdf";
import { useLocation } from "react-router";

const PreviousQuestions = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ques_pdf_file_url: null,
      ans_pdf_file_url: null,
    },
  });
  const location = useLocation()
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  const pathName = location?.pathname;

  const isView = hasPermission(user, pathName, "isView");
  const isUpdate = hasPermission(user, pathName, "isUpdate");
  const isDelete = hasPermission(user, pathName, "isDelete");
  const isCreate = hasPermission(user, pathName, "isCreate");

  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [classList, setClassList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [sessionList, setSessionList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fileType, setFileType] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const toggleImageModal = () => {
    setModalOpen(true);
  };
  const [columns, setColumns] = useState([
    {
      name: "Session",
      selector: (row) => row?.session_name,
      sortable: true,
      wrap:true
    },
    {
      name: "Class",
      selector: (row) => row?.class_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Stream",
      selector: (row) => row?.stream_name || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Subject",
      selector: (row) => row?.subject_name,
      sortable: true,
      wrap: true,
    },

    {
      name: "Content Language",
      selector: (row) => row?.language,
      sortable: true,
    },

    {
      name: "Question",
      selector: (row) => row?.ques_pdf_file,
      wrap: true,
      cell: (row) => {
        const fileUrl = `${BASE_URL_IMG_LMS}${row?.ques_pdf_file}`;

        return (
          <div className="upload-image-div my-2">
            <Button
              outline
              id={`doc-${row.id}`}
              color="danger"
              type="button"
              onClick={() => handleImageClick(row, fileUrl)}
              size="xxl"
              data-toggle="tooltip"
              data-placement="top"
              title="View Document"
              className="mb-2"
            >
              <FaFilePdf style={{ height: "1rem", width: "1rem" }} />
            </Button>
          </div>
        );
      },
    },
    {
      name: "Answer Key",
      selector: (row) => row?.ans_pdf_file,
      wrap: true,
      cell: (row) => {
        const fileUrl = `${BASE_URL_IMG_LMS}${row?.ans_pdf_file}`;

        return (
          <div className="upload-image-div my-2">
            <Button
              outline
              id={`doc-${row.id}`}
              color="danger"
              type="button"
              onClick={() => handleImageClick(row, fileUrl)}
              size="xxl"
              data-toggle="tooltip"
              data-placement="top"
              title="View Document"
              className="mb-2"
            >
              <FaFilePdf style={{ height: "1rem", width: "1rem" }} />
            </Button>
          </div>
        );
      },
    },

    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          {isUpdate && (
            <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
              {" "}
              <Icon name="edit" />
            </Button>
          )}
          {isDelete && (
            <Button outline color={`danger`} size={`xs`} className={`me-1`} onClick={() => deleteToggle(row)}>
              {" "}
              <Icon name="trash" />
            </Button>
          )}
        </div>
      ),
    },
  ]);
  const getFileTypeFromUrl = (url) => {
    if (typeof url !== "string") return "";
    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      return "youtube";
    }
    const fileExtension = url.split(".").pop().split(/#|\?/)[0];
    return fileExtension.toLowerCase();
  };
  const handleImageClick = (a, b) => {
    setValue("image_url", b);
    setValue("subject_name", a?.subject_name || "");
    const image = watch("image_url");
    const fileType = getFileTypeFromUrl(image);

    setFileType(fileType);
    if (fileType === "pdf") {
      setModalImages([image]); // PDF file
    } else if (fileType === "youtube") {
      setModalImages([image]); // Set the YouTube URL
    } else {
      setModalImages([image]); // Image file
    }
    toggleImageModal(); // Open the modal
  };
  useEffect(() => {
    getClass();
    getSession();
    getPreviousYearQuestions();
  }, []);
  const getPreviousYearQuestions = () => {
    setIsLoading(true);
    const data = {};
    listLMSPreviousYearQuestionAPI(data)
      .then((res) => {
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setData(res.data.data);
          setIsLoading(false);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.clearWaitingQueue();
          setData([]);
          setIsLoading(false);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getSession = () => {
    const data = {};
    getSessionDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setSessionList(res.data.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.clearWaitingQueue();
          setSessionList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getClass = () => {
    const data = {};
    getClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setClassList(res.data.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.clearWaitingQueue();
          setClassList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleSessionChange = (sel) => {
    setValue("session", sel);
    trigger("session");
  };
  const handleClassChange = (selectedOption) => {
    setValue("class", selectedOption || "");
    trigger("class");
    if (watch("mode") == "Add") {
      setValue("stream", "");
      setValue("subject", "");
      // trigger("subject");
      setValue("chapter", "");
      // trigger("chapter");
    }
    const body = {
      class_id: selectedOption?.value,
    };
    if (selectedOption?.value == "1" || selectedOption?.value == "4") {
      getSubjectByClass(body);
    }
    if (selectedOption?.value == "2" || selectedOption?.value == "3") {
      getStreamByClass(body);
    }
  };
  const getSubjectByClass = (body) => {
    getSubjectByClassLMSDD(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setSubjectList(res.data.data);
        } else if (status === false) {
          setSubjectList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  const getStreamByClass = (data) => {
    getStreamByClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === "expired") {
          setValue("streamList", []);
          toast.error(res.data.message);
          logout();
        } else if (status === true) {
          toast.success(res.data.message);
          setValue("streamList", res.data.data);
          toast.clearWaitingQueue();
        } else {
          toast.warning(res.data.message);
          setValue("streamList", []);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleStreamChange = (selectedOption) => {
    setValue("stream", selectedOption || "");
    trigger("stream");
    if (watch("mode") == "Add") {
      setValue("subject", "");
      setValue("chapter", "");
    }
    const body = {
      class_id: watch("class")?.value,
      stream_id: watch("stream")?.value,
    };
    getSubjectByClass(body);
  };
  const handleSubjectChange = (selectedOption) => {
    setValue("subject", selectedOption || "");
    trigger("subject");
  };
  const handleFileChange = (e, errorInput, url) => {
    const file = e.target.files[0];
    if (file) {
      ValidatePdf(file, (isValid, message) => {
        if (isValid) {
          setValue(errorInput, file); // Set as File object, not string
          const imageUrl = URL.createObjectURL(file);
          setValue(url, imageUrl);
          trigger(errorInput);
          console.log("jhjhjhjh", file);
          setTimeout(() => clearErrors(errorInput), 100);
        } else {
          setError(errorInput, {
            type: "manual",
            message: message,
          });
          e.target.value = "";
        }
      });
    } else {
      setValue(errorInput, "");
    }
  };
  const handleContentLanguageChange = (sel) => {
    setValue("language", sel);
    trigger("language");
  };

  const onFormSubmit = (data) => {
    const formData = new FormData();
    formData.append("session", watch("session")?.value);
     if(user?.role=="Subject Specialist"){
      formData.append("class_id", user.class_id);
      formData.append("subject", user.subject_id);
    }else{
       formData.append("class_id", data.class?.value);
      formData.append("subject", data.subject?.value);
    }
    // formData.append("class_id", watch("class")?.value);
    // formData.append("subject", watch("subject")?.value);
    formData.append("language", watch("language")?.value);
    if (watch("class")?.value == 2 || watch("class")?.value == 3) {
      formData.append("stream_id", data?.stream?.value);
    }
    if (watch("ques_pdf_file") != null) {
      formData.append("ques_pdf_file", data?.ques_pdf_file);
    }else{
        formData.append("ques_pdf_file", watch("ques_file"));

    }
    if (watch("ans_pdf_file") != null) {
      formData.append("ans_pdf_file", data?.ans_pdf_file);
    }else{
        formData.append("ans_pdf_file", watch("ans_file"));

    }
    if (mode == "Edit") {
      formData.append("id", watch("id"));
    }
    if (mode == "Add") {
      addLMSPreviousYearQuestionAPI(formData)
        .then((res) => {
          const status = res.data.status;
          if (status === true) {
            console.log("res--->success", res.data);
            getPreviousYearQuestions();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === false) {
            setIsLoading(false);
            toast.error(res.data.message);
            console.log("res--->failed", res.data);
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          toast.error("err");
        });
    }
    if (mode == "Edit") {
      updateLMSPreviousYearQuestionAPI(formData)
        .then((res) => {
          const status = res.data.status;
          if (status === true) {
            console.log("res--->success", res.data);
            getPreviousYearQuestions();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === false) {
            setIsLoading(false);
            toast.error(res.data.message);
            console.log("res--->failed", res.data);
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          toast.error(err?.message);
        });
    }
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(true);
    setMode("Edit");
    setValue("id", row?.id);
    setValue("subject", {
      label: row?.subject_name,
      value: row?.subject_id,
    });
    trigger("subject");
    setValue("class", {
      label: row.class_name,
      value: row.class_id,
    });
    
    setValue("language", {
      label: row.language,
      value: row.language,
    });
    setValue("session", {
      label: row.session_name,
      value: row.session,
    });
    setValue("ques_pdf_file_url", BASE_URL_IMG_LMS + row?.ques_pdf_file);
    setValue("ques_file", row?.ques_pdf_file);
    setValue("ques_pdf_file_type", "application/pdf");
    setValue("ans_pdf_file_url", BASE_URL_IMG_LMS + row?.ans_pdf_file);
    setValue("ans_file",  row?.ans_pdf_file);
    setValue("ans_pdf_file_type", "application/pdf");
    const body = {
      class_id: row.class_id,
    };
    const payload = {
      subject_id: row.subject_id,
    };
    if (row?.class_id == 1 || row?.class_id == 4) {
      getSubjectByClass(body); 
    }
    if (row?.class_id == 2 || row?.class_id == 3) {
      const body = {
        value: row?.class_id,
        label: row?.class_name,
      };
      handleClassChange(body);
      const payload = {
        value: row?.stream_id,
        label: row?.stream_name,
      };

      handleStreamChange(payload);
    }
  };
  const deleteToggle =(row)=>{
    console.log("handle delete")
  }
  return (
    <>
      <Head title={"Previous Year Questions and Answers"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Previous Year Questions and Answers"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div>
                <Button
                  color={"primary"}
                  outline
                  className={"me-n1"}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    reset();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className={"g-gs"}>
            {isOpen ? (
              <Card className="p-5">
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row className={"g-gs"}>
                    <Col md={2}>
                      <div className="form-group">
                        <Label className="form-label" htmlFor="session">
                          Session
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="session"
                            options={sessionList}
                            {...register("session", {
                              required: "Please select session",
                            })}
                            onChange={handleSessionChange}
                            value={watch("session")}
                          />
                          {errors.session && <span className="invalid">{errors?.session?.message}</span>}
                        </div>
                      </div>
                    </Col>
                    {/* Class */}
                       {user?.role=="Subject Specialist"?null: <Col md={`2`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="class">
                          Class
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="class"
                            options={classList}
                            {...register("class", {
                              required: "Please select class",
                            })}
                            onChange={handleClassChange}
                            value={watch("class")}
                          />
                          {errors.class && <span className="invalid">{errors?.class?.message}</span>}
                        </div>
                      </div>
                    </Col>}
                    {/* Stream */}
                        {user?.role=="Subject Specialist"?null: <>{(watch("class")?.value == "2" || watch("class")?.value == "3") && (
                      <Col md={`2`}>
                        <div className="form-group">
                          <Label className="from-label" htmlFor="stream">
                            Stream
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <Select
                              className=""
                              id="stream"
                              options={watch("streamList")}
                              {...register("stream", {
                                required: "Please select stream",
                              })}
                              onChange={handleStreamChange}
                              value={watch("stream")}
                            />
                            {errors.stream && (
                              <span
                                className="invalid"
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors?.stream?.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                    )}</>}
                    {/* Subject */}
                        {user?.role=="Subject Specialist"?null:<Col md={`2`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="subject">
                          Subject
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="subject"
                            options={subjectList}
                            {...register("subject", {
                              required: "Please select subject",
                            })}
                            onChange={handleSubjectChange}
                            value={watch("subject")}
                          />
                          {errors.subject && <span className="invalid">{errors?.subject?.message}</span>}
                        </div>
                      </div>
                    </Col>}
                    {/* Content Language */}
                    <Col md={`2`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="language">
                          Content Language
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="language"
                            options={[
                              { value: "Hindi", label: "Hindi" },
                              { value: "English", label: "English" },
                              { value: "Sanskrit", label: "Sanskrit" },
                              { value: "Urdu", label: "Urdu" },
                            ]}
                            {...register("language", {
                              required: "Please select content type",
                            })}
                            onChange={handleContentLanguageChange}
                            value={watch("language")}
                          />
                          {errors.language && <span className="invalid">{errors?.language?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    <PdfUpload
                      handleImageChange={handleFileChange}
                      register={register}
                      errors={errors}
                      setValue={setValue}
                      setError={setError}
                      clearErrors={clearErrors}
                      watch={watch}
                      label="Question Paper"
                      image="ques_pdf_file"
                      image_url="ques_pdf_file_url"
                      validate={true} // Enable validation
                      required
                    />
                    <PdfUpload
                      handleImageChange={handleFileChange}
                      register={register}
                      errors={errors}
                      setValue={setValue}
                      setError={setError}
                      clearErrors={clearErrors}
                      watch={watch}
                      label="Answer key"
                      image="ans_pdf_file"
                      image_url="ans_pdf_file_url"
                      validate={true} // Enable validation
                      required
                    />
                  </Row>
                  <Col md="2" className={``}>
                    <MyButton isLoading={isLoading} mode={mode} />
                  </Col>
                </Form>
              </Card>
            ) : null}
            <MyDataTable data={data} columns={columns} title={"Previous Year Questions"} isLoading={isLoading} />
          </Row>
        </Block>
      </Content>
      <ViewImgAndPdf
        fileType={fileType}
        titleName={watch("subject_name")}
        isOpen={modalOpen}
        toggleModal={toggleModal}
        images={modalImages}
        currentImageIndex={currentImageIndex}
        setCurrentImageIndex={setCurrentImageIndex}
      />
    </>
  );
};

export default PreviousQuestions;
